import { simpleSelectorCreator } from 'shared/helpers';
import { reducerNames } from 'shared/constants';

const sub = `${reducerNames.loaded}.`;

export const getAgents = simpleSelectorCreator(`${sub}agents`, []);

export const getAgent = simpleSelectorCreator(`${sub}agents[0]`, null);

export default {};
